export const getReadingTime = (htmlContent) => {
  if (!htmlContent) return 1;
  const words = htmlContent
    .replace(/<[^>]*>/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
};
